export function subscribeBeforeUnload(message: string): () => void {
  const handler = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = message; // Для старых браузеров
    return message;
  };

  window.addEventListener('beforeunload', handler);

  // Возвращаем функцию отписки
  return () => {
    window.removeEventListener('beforeunload', handler);
  };
}

export const checkIsValidJSON = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
